/**
 * @module app.portal.glpiProblemsCtrl
 */
function GlpiProblemsCtrl($scope, glpiService, $root) {
    let self = this;

    self.isLoading = false;
    self.problem = null
    self.error = {};
    self.id = null;

    // Get GLPI store's tickets
    self.getProblem = function () {
        self.error = {};
        self.isLoading = true;
        glpiService
            .getGLPIProblems(self.id)
            .then(function(problem) {
                self.problem = problem;
                if (!self.problem) {
                    self.error = {
                        error: true,
                        message: 'Aucun problème en cours à afficher'
                    };
                }
                self.isLoading = false;
            })
            .catch(function(err) {
                self.error = {
                    error: true,
                    class: 'alert-danger',
                    message:
                        'Une erreur est survenue' +
                        (err.statusText ? ' : [' + err.status + '] ' + err.statusText + ' - ' + err.problems : '')
                };
                self.isLoading = false;
            });

    }

    function _offline() {
        self.error = {
            error: true,
            message: 'Vous ne pouvez pas accéder aux tickets GLPI en mode hors ligne'
        };
    }

    function _online() {
        self.problems = null;
        self.error = {};
    }

    if ($root.online) {
        _online();
    }
    else {
        _offline();
    }

    $root.$on('online', _online);

    $root.$on('offline', _offline);
}

GlpiProblemsCtrl.$inject = ['$scope', 'glpiService', '$rootScope'];

angular.module('app.portal.glpiProblemsCtrl', []).controller('GlpiProblemsCtrl', GlpiProblemsCtrl);
